import { markdownParser } from '../../../utils/markdown-parser'
import React from 'react'

const PlatinumRichText = (markupText: string, containerName: string = '') => {
  const parsed = markdownParser(markupText, containerName)
  return <div className='platinum-rich-text' dangerouslySetInnerHTML={{ __html: parsed }} />
}
export default PlatinumRichText
